import styled from 'styled-components';

export const ChangeLanguageWrapper = styled.div`
  color: ${({ color }) => color ?? 'inherit'};

  .language__select {
    color: ${({ color }) => color ?? 'inherit'};
  }
`;
export const ChangeLanguageSelectWrapper = styled.select`
  color: ${({ color }) => color ?? 'inherit'};
`;
